import { render, staticRenderFns } from "./ordersDetails.vue?vue&type=template&id=db363766&"
import script from "./ordersDetails.vue?vue&type=script&lang=js&"
export * from "./ordersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports